import { combineReducers } from "redux";
import { createAuthReducer } from "@tshio/redux-api-auth-middleware";

import oauth from "./oauth";
import ui from "./ui";
import passcodeManager from "./passcodeManager";
import billing from "./billing";
import projectmail from "./projectmail";

const tmpReducer = combineReducers({
  auth: createAuthReducer({}), // "@tshio/redux-api-auth-middleware"
  ui,
  oauth,
  passcodeManager,
  billing,
  projectmail,
});

const rootReducer = (state, action) => {
  return tmpReducer(state, action);
};

export default rootReducer;
